import { Text, View } from '@react-pdf/renderer';
import { styles } from './styles';
import CircleChart from '../../charts/CircleChart/CircleChart';

function EngagementCards({
  employees,
  engagedUsers3,
  engagedMonitored,
  engagedFunded,
  engagedRewardUsers,
  totalUsers3,
  endOfMonthUsers,
  successfulRewards,
  completedRewards,
}) {
  return (
    <>
      <View style={styles.engagementContainer}>
        <View style={styles.engagementItem}>
          <CircleChart
            progress={employees ? Number(endOfMonthUsers / employees) : 0}
            progressColor="#16BFBB"
          />
          <Text style={styles.engagementItemTitle}>Adoption</Text>
          <Text style={styles.engagementItemValue}>
            {employees
              ? `${Number((endOfMonthUsers / employees) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {employees ? `${endOfMonthUsers} out of ${employees} \n eligible employees*` : '---'}
          </Text>
        </View>
        <View style={styles.engagementItem}>
          <CircleChart
            progress={endOfMonthUsers ? Number(engagedMonitored / endOfMonthUsers) : 0}
            progressColor="#EB7AF5"
          />
          <Text style={styles.engagementItemTitle}>Monitoring</Text>
          <Text style={styles.engagementItemValue}>
            {endOfMonthUsers
              ? `${Number((engagedMonitored / endOfMonthUsers) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {endOfMonthUsers ? `${engagedMonitored} out of ${endOfMonthUsers} users` : '---'}
          </Text>
        </View>
        <View style={styles.engagementItem}>
          <CircleChart
            progress={engagedMonitored ? Number(engagedFunded / engagedMonitored) : 0}
            progressColor="#50E5FF"
          />
          <Text style={styles.engagementItemTitle}>Funding</Text>
          <Text style={styles.engagementItemValue}>
            {engagedMonitored
              ? `${Number((engagedFunded / engagedMonitored) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {engagedMonitored
              ? `${engagedFunded} out of ${engagedMonitored} monitored users`
              : '---'}
          </Text>
        </View>
      </View>
      <View style={styles.engagementContainer}>
        <View style={[styles.engagementItem, styles.engagementItemBottom]}>
          <CircleChart
            progress={totalUsers3 ? Number(engagedUsers3 / totalUsers3) : 0}
            progressColor="#350569"
          />
          <Text style={styles.engagementItemTitle}>Quarterly Active Users**</Text>
          <Text style={styles.engagementItemValue}>
            {totalUsers3
              ? `${Number((engagedUsers3 / totalUsers3) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {totalUsers3 ? `${engagedUsers3} out of ${totalUsers3} users` : '---'}
          </Text>
        </View>
        <View style={[styles.engagementItem, styles.engagementItemBottom]}>
          <CircleChart
            progress={endOfMonthUsers ? Number(engagedRewardUsers / endOfMonthUsers) : 0}
            progressColor="#350569"
          />
          <Text style={styles.engagementItemTitle}>Rewards Engagement</Text>
          <Text style={styles.engagementItemValue}>
            {endOfMonthUsers
              ? `${Number((engagedRewardUsers / endOfMonthUsers) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {endOfMonthUsers ? `${engagedRewardUsers} out of ${endOfMonthUsers} users` : '---'}
          </Text>
        </View>
        <View style={[styles.engagementItem, styles.engagementItemBottom]}>
          <CircleChart
            progress={completedRewards ? Number(successfulRewards / completedRewards) : 0}
            progressColor="#350569"
          />
          <Text style={styles.engagementItemTitle}>Rewards Success Rate</Text>
          <Text style={styles.engagementItemValue}>
            {completedRewards
              ? `${Number((successfulRewards / completedRewards) * 100).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })}%`
              : 'N/A'}
          </Text>
          <Text style={styles.engagementItemText}>
            {completedRewards
              ? // eslint-disable-next-line max-len
                `${successfulRewards} successful completions out of ${completedRewards} completed rewards`
              : '---'}
          </Text>
        </View>
      </View>
    </>
  );
}

export default EngagementCards;
